import React, { useMemo } from 'react';
import { number } from 'prop-types';
import { v4 as uuidv4 } from 'uuid';

import '../styles/ChildCategoriesSkeleton.css';

const generateId = () => (
    uuidv4()
);

function ChildCategoriesSkeleton ({ childCollectionsCount }) {
    const skeletonKeys = useMemo(
        () => Array.from({ length: childCollectionsCount }, generateId),
        [childCollectionsCount]
    );

    return (
        <div
            className={'child-categories-skeleton'}
            style={{ marginBottom: '4em' }}
        >
            <div
                className={'skeleton'}
                style={{ height: '45px' }}
            />
            <div
                className={'child-categories-skeleton-content'}
            >
                {skeletonKeys.map((key) => (
                    <div
                        key={key}
                        style={{ width: '70%' }}
                        className={'skeleton'}/>
                ))}
            </div>
        </div>
    );
}

ChildCategoriesSkeleton.propTypes = {
    childCollectionsCount: number,
};

export default ChildCategoriesSkeleton;